import { motion } from "framer-motion";
import {
  FaCuttlefish,
  FaMicrochip,
  FaProjectDiagram,
  FaCog,
  FaCubes,
  FaBrain,
  FaUsers,
  FaPython,
  FaRobot,
  FaHtml5,
  FaCss3Alt,
  FaJs,
} from "react-icons/fa";
import { LuCircuitBoard } from "react-icons/lu";

export default function About() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 25 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-4xl mx-auto px-4 py-16"
    >
      {/* Header */}
      <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-center">
        About Me
      </h1>
      <div className="h-1 w-24 bg-blue-600 rounded-full mx-auto mb-12"></div>

      {/* Bio Section */}
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8">
        {/* Profile Image */}
        <img
          src="/images/profile.jpg" // replace with your picture
          alt="Profile"
          className="w-48 h-48 object-cover rounded-full shadow-lg"
        />

        {/* Description */}
        <div className="flex-1 space-y-4">
          <p className="text-lg text-gray-700 leading-relaxed">
            Hi! I’m 17 and I love competing, coding, building robots, singing,
            sports, badminton, and more.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Over the years, I’ve learned mechanical design, C and Arduino
            coding. Every project and competition helps me improve.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            When I’m not creating robots, I enjoy exploring AI, coding personal
            projects, and other hobbies.
          </p>
        </div>
      </div>

      {/* Skills Section */}
      <div className="mt-16">
        <h2 className="text-3xl font-semibold text-gray-900 mb-6 text-center">
          Skills
        </h2>
        <div className="h-1 w-24 bg-blue-600 rounded-full mx-auto mb-8"></div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <SkillCard
            icon={<FaMicrochip className="text-green-500 text-3xl mb-2" />}
            label="Arduino"
          />
          <SkillCard
            icon={<FaRobot className="text-yellow-500 text-3xl mb-2" />}
            label="Robotics Design"
          />
          <SkillCard
            icon={<FaCog className="text-red-500 text-3xl mb-2" />}
            label="PID & Control Algorithms"
          />
          <SkillCard
            icon={<FaCubes className="text-purple-500 text-3xl mb-2" />}
            label="3D Modeling"
          />
          <SkillCard
            icon={<LuCircuitBoard className="text-purple-500 text-3xl mb-2" />}
            label="PCB Design"
          />
          <SkillCard
            icon={<FaPython className="text-yellow-500 text-3xl mb-2" />}
            label="Python"
          />
          <SkillCard
            icon={<FaHtml5 className="text-orange-500 text-3xl mb-2" />}
            label="HTML"
          />
          <SkillCard
            icon={<FaCss3Alt className="text-blue-600 text-3xl mb-2" />}
            label="CSS"
          />
          <SkillCard
            icon={<FaJs className="text-yellow-400 text-3xl mb-2" />}
            label="JavaScript"
          />
          <SkillCard
            icon={<FaCuttlefish className="text-blue-500 text-3xl mb-2" />}
            label="C"
          />{" "}
          <SkillCard
            icon={<FaBrain className="text-indigo-500 text-3xl mb-2" />}
            label="Problem Solving"
          />
          <SkillCard
            icon={<FaUsers className="text-pink-500 text-3xl mb-2" />}
            label="Team Collaboration"
          />
        </div>
      </div>
    </motion.div>
  );
}

function SkillCard({ icon, label }) {
  return (
    <div className="bg-white h-32 flex flex-col items-center justify-center rounded-xl shadow-md text-center p-4 transition transform hover:-translate-y-2 hover:shadow-xl">
      {icon}
      <p className="font-semibold text-gray-800">{label}</p>
    </div>
  );
}
